import { from } from 'rxjs';
import { filter, mergeMap, startWith } from 'rxjs/operators';

import { COAST_SUPPORT_EMAIL, COAST_VOICE_PHONE } from '../../../env';
import {
  lookupAddressFail,
  lookupAddressSuccess,
  setAddressLookupType,
  setEnteredAddress,
} from '../../../features/address-verification/reducers/addressLookup';
import { savePreviewCardInfo } from '../../../features/application/reducers/business-info';
import { RootEpic } from '../index';

export const savePreviewCardEpic: RootEpic = (action$, _state$, { api }) =>
  action$.pipe(
    filter((action) => savePreviewCardInfo.match(action)),
    mergeMap(({ payload: { address } }) => {
      return from(
        api.addressLookup
          .lookupAddressCardOrders(address)
          .then(lookupAddressSuccess)
          .catch(() => {
            return lookupAddressFail({
              message:
                'Our server is having trouble verifying your address, ' +
                'please try again. If you continue to see this error, ' +
                `email us at ${COAST_SUPPORT_EMAIL}, or call us at ${COAST_VOICE_PHONE}`,
            });
          }),
      ).pipe(startWith(setAddressLookupType('shipping'), setEnteredAddress(address)));
    }),
  );
